import type { GetServerSideProps, GetServerSidePropsResult } from "next"
import type { FC } from "react"

import ErrorBoundary from "@/common/components/ErrorBoundary"
import { TALLY_DEFAULT_SOCIAL_PREVIEW } from "@/common/constants/logo"
import OrganizationToggleLaunch from "@/organization/components/onboarding/OrganizationToggleLaunch"
import MainLayout from "@/ui/layouts/main/MainLayout"
import MainLayoutContainer from "@/ui/layouts/main/MainLayoutContainer"
import MainLayoutFooter from "@/ui/layouts/main/MainLayoutFooter"
import MainLayoutHead from "@/ui/layouts/main/MainLayoutHead"
import MainLayoutHeader from "@/ui/layouts/main/MainLayoutHeader"
import { isWhitelabel } from "@/whitelabel/hooks/useIsWhiteLabel"

type Props = {}

const GetStartedPage: FC = () => {
  const title = "Tally | Get Started"
  const preview = {
    title: "Tally | Get Started",
    image: TALLY_DEFAULT_SOCIAL_PREVIEW,
    description:
      "Tally is a DAO operations platform. DAOs use Tally to create and pass proposals, enable delegation, and power voting.",
  }

  return (
    <ErrorBoundary section="Organization">
      <MainLayout>
        <MainLayoutHead preview={preview} title={title} />
        <MainLayoutHeader />
        <MainLayoutContainer>
          <ErrorBoundary section="GetStartedOnboardingPage">
            <OrganizationToggleLaunch />
          </ErrorBoundary>
        </MainLayoutContainer>
        <MainLayoutFooter mt={{ base: 10, lg: 20 }} />
      </MainLayout>
    </ErrorBoundary>
  )
}

export const getServerSideProps: GetServerSideProps = async (
  context,
): Promise<GetServerSidePropsResult<Props>> => {
  if (isWhitelabel(context)) {
    return {
      redirect: {
        permanent: false,
        destination: "/404",
      },
    }
  }

  return {
    props: {},
  }
}

export default GetStartedPage
